<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      d="M12.909 2.90909C12.909 2.40702 12.502 2 11.9999 2C11.4978 2 11.0908 2.40702 11.0908 2.90909V3.81818C11.0908 4.32025 11.4978 4.72727 11.9999 4.72727C12.502 4.72727 12.909 4.32025 12.909 3.81818V2.90909Z"
    />
    <path
      d="M12.909 20.1818C12.909 19.6797 12.502 19.2727 11.9999 19.2727C11.4978 19.2727 11.0908 19.6797 11.0908 20.1818V21.0909C11.0908 21.593 11.4978 22 11.9999 22C12.502 22 12.909 21.593 12.909 21.0909V20.1818Z"
    />
    <path
      d="M19.07 4.92997C19.425 5.28498 19.425 5.86059 19.07 6.21561L18.4244 6.86107C18.0694 7.21608 17.4939 7.21608 17.1388 6.86107C16.7838 6.50605 16.7838 5.93044 17.1388 5.57542L17.7843 4.92997C18.1394 4.57494 18.7149 4.57494 19.07 4.92997Z"
    />
    <path
      d="M6.86094 18.4246C7.21597 18.0696 7.21597 17.494 6.86094 17.139C6.50592 16.784 5.93031 16.784 5.57529 17.139L4.92984 17.7844C4.57482 18.1394 4.57482 18.7151 4.92984 19.0701C5.28486 19.4251 5.86046 19.4251 6.21548 19.0701L6.86094 18.4246Z"
    />
    <path
      d="M19.2729 12C19.2729 11.4979 19.6799 11.0909 20.182 11.0909H21.0911C21.5932 11.0909 22.0002 11.4979 22.0002 12C22.0002 12.5021 21.5932 12.9091 21.0911 12.9091H20.182C19.6799 12.9091 19.2729 12.5021 19.2729 12Z"
    />
    <path
      d="M2.90909 11.0909C2.40702 11.0909 2 11.4979 2 12C2 12.5021 2.40702 12.9091 2.90909 12.9091H3.81818C4.32025 12.9091 4.72727 12.5021 4.72727 12C4.72727 11.4979 4.32025 11.0909 3.81818 11.0909H2.90909Z"
    />
    <path
      d="M17.1388 17.139C17.4939 16.784 18.0694 16.784 18.4244 17.139L19.07 17.7844C19.425 18.1394 19.425 18.7151 19.07 19.0701C18.7149 19.4251 18.1394 19.4251 17.7843 19.0701L17.1388 18.4246C16.7838 18.0696 16.7838 17.494 17.1388 17.139Z"
    />
    <path
      d="M6.21548 4.92997C5.86046 4.57494 5.28486 4.57494 4.92984 4.92997C4.57482 5.28498 4.57482 5.86059 4.92984 6.21561L5.57529 6.86107C5.93031 7.21608 6.50592 7.21608 6.86094 6.86107C7.21597 6.50605 7.21597 5.93044 6.86094 5.57542L6.21548 4.92997Z"
    />
    <path
      d="M8.14301 8.14307C10.2731 6.01294 13.7268 6.01294 15.8569 8.14307C17.987 10.2732 17.987 13.7268 15.8569 15.8569C13.7268 17.9871 10.2731 17.9871 8.14301 15.8569C6.01288 13.7268 6.01288 10.2732 8.14301 8.14307Z"
    />
  </svg>
</template>
